import {
  ConsentOrdersFutureNeedsSchema,
  FutureNeedsIcon,
  InitialDetails,
  RadioSelect,
  TextArea
} from "@fla/components";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

interface IProps {
  formId: string;
  store: InitialDetails;
  onSubmit: (values: InitialDetails) => void;
}

export default function FutureNeeds({ onSubmit, formId, store }: IProps) {
  const { handleSubmit, watch, control, setValue } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(ConsentOrdersFutureNeedsSchema(store))
  });

  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-8 pb-8 border-b">
        <FutureNeedsIcon classes="w-16 h-16 mx-auto mb-5" />
        <h3 className="text-center">Future Needs</h3>
      </div>

      <div className="bg-[#f2f2f2] p-2 md:p-5 rounded-lg space-y-3">
        <RadioSelect
          title={`Have you or ${store?.spouse?.first_name} acquired or disposed of any property since the date of separation?`}
          subTitle="For example, have you sold or purchased property, split funds in a joint bank account, sold or purchased a car, sold or purchased a business, sold or purchased shares etc"
          control={control}
          name="future_needs.acquired_or_disposed"
          id="future_needs.acquired_or_disposed"
          options={["yes", "no"]}
          onChange={val => {
            if (val === "no") {
              setValue("future_needs.acquired_or_disposed_details", "");
            }
          }}
          theme="dark"
        />

        {watch("future_needs.acquired_or_disposed") === "yes" ? (
          <TextArea
            title="Give Details"
            control={control}
            name="future_needs.acquired_or_disposed_details"
            id="future_needs.acquired_or_disposed_details"
            placeholder="details"
            theme="dark"
          />
        ) : null}
      </div>

      <div className="bg-[#f2f2f2] p-2 md:p-5 rounded-lg space-y-3">
        <RadioSelect
          title={`Do you or ${store?.spouse?.first_name} have any health issues that prevent either of you working at full capacity or undertaking gainful employment?`}
          control={control}
          name="future_needs.health_issues"
          id="future_needs.health_issues"
          options={["yes", "no"]}
          onChange={val => {
            if (val === "no") {
              setValue("future_needs.health_issues_details", "");
            }
          }}
          theme="dark"
        />

        {watch("future_needs.health_issues") === "yes" ? (
          <TextArea
            title="Give Details"
            control={control}
            name="future_needs.health_issues_details"
            id="future_needs.health_issues_details"
            placeholder="details"
            theme="dark"
          />
        ) : null}
      </div>

      <div className="bg-[#f2f2f2] p-2 md:p-5 rounded-lg space-y-3">
        <RadioSelect
          title={`Are either you or ${store?.spouse?.first_name} currently earning less than your earning potential?`}
          subTitle="E.g could be earning more with same skills or qualifications"
          control={control}
          name="future_needs.earning_less_potential"
          id="future_needs.earning_less_potential"
          options={["yes", "no"]}
          onChange={val => {
            if (val === "no") {
              setValue("future_needs.earning_less_potential_details", "");
            }
          }}
          theme="dark"
        />

        {watch("future_needs.earning_less_potential") === "yes" ? (
          <TextArea
            title="Give Details"
            control={control}
            name="future_needs.earning_less_potential_details"
            id="future_needs.earning_less_potential_details"
            placeholder="details"
            theme="dark"
          />
        ) : null}
      </div>

      <div className="bg-[#f2f2f2] p-2 md:p-5 rounded-lg space-y-3">
        <RadioSelect
          title={`Do either you or ${store?.spouse?.first_name} need to re-train, re-qualify, or update a qualification to find work?`}
          control={control}
          name="future_needs.requalify_work"
          id="future_needs.requalify_work"
          options={["yes", "no"]}
          onChange={val => {
            if (val === "no") {
              setValue("future_needs.requalify_work_details", "");
            }
          }}
          theme="dark"
        />
        {watch("future_needs.requalify_work") === "yes" ? (
          <TextArea
            title="Give Details"
            control={control}
            name="future_needs.requalify_work_details"
            id="future_needs.requalify_work_details"
            placeholder="details"
            theme="dark"
          />
        ) : null}
      </div>
      {/*  */}
      <div className="bg-[#f2f2f2] p-2 md:p-5 rounded-lg space-y-3">
        <RadioSelect
          title={`Have you or ${store?.spouse?.first_name} entered into a new relationship after separation?`}
          control={control}
          name="future_needs.new_relationship"
          id="future_needs.new_relationship"
          options={["yes", "no"]}
          onChange={val => {
            if (val === "no") {
              setValue("future_needs.new_relationship_details", "");
            }
          }}
          theme="dark"
        />
        {watch("future_needs.new_relationship") === "yes" ? (
          <TextArea
            title="Give Further Details"
            control={control}
            name="future_needs.new_relationship_details"
            id="future_needs.new_relationship_details"
            placeholder="details"
            subTitle="Provide details about the length of the new relationship, whether living together (and for how long), if there are children with the new partner, or if any property or assets have been purchased with the new partner."
            theme="dark"
          />
        ) : null}
      </div>

      {store?.children?.if_children === "yes" ? (
        <TextArea
          title="Who will be the primary caregiver of the children post separation?"
          control={control}
          name="future_needs.primary_caregiver_after_separation"
          id="future_needs.primary_caregiver_after_separation"
          placeholder=""
        />
      ) : null}
    </form>
  );
}

/*




input box 
Full Name Of Other Primary Caregiver

*/
